<template>
	
  <div class="p-grid">
    <div class="p-col">
      <ScrollPanel class="alarms-scrollpanel" v-if="alarms" style="width: 100%; height: 370px; padding-left: 0;">
        <Accordion class="alarm-accordion" :activeIndex="[0]" :multiple="true" expandIcon="p-accordion-toggle-icon pi pi-chevron-down" collapseIcon="p-accordion-toggle-icon pi pi-chevron-up">
              <AccordionTab v-for="(value, name) in alarms" :key="name">
                  <template #header>
                      <span class="icon-calendar" style="font-size: 20px; margin-right: .8rem;"/>
                      <span>{{formatDate(name)}}</span>
                  </template>
                  <div v-for="alarm in value" :key="alarm.timestamp" :class="['alarm',{'alarm-inactive':!alarm.active}]">
                    <img v-if="alarm.active" src="assets/irinox/icons/alarm_active.svg" :alt="$t('common.active')"/> 
                    <img v-else src="assets/irinox/icons/alarm_inactive.svg" :alt="$t('common.inactive')"/>
                    <span class="alarm-name">{{alarm.name?$t('alarms.'+alarm.name):"-"}}</span>
                    <span class="alarm-code">&nbsp;({{alarm.name}})</span>
                    <span class="alarm-time">{{formatTime(alarm.timestamp)}}</span> 
                  </div>
              </AccordionTab>
        </Accordion>
      </ScrollPanel>
      <div v-else class="p-mt-1">
        {{$t('details.no_alarm_found')}}
      </div>
    </div>
  </div>

</template>

<script>
// import AlarmAccordion from "../AlarmAccordion.vue";
import { mapGetters } from 'vuex';

export default {
    components: {
      // AlarmAccordion,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          is24hour: 'userdata/is24hour',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        alarms: function() {
          if(this.appliance && this.appliance.alarms) {
            let a = this.$functions.clone(this.appliance.alarms);
            if(a!=null && a.length>0) {
              a.sort((a,b) => this.$functions.compareNumbers(a, b, "timestamp"));
              let aObj = {};
              for(let i=0; i<a.length; i++) {
                // let key = new Date(a[i].timestamp * 1000).toISOString().slice(0, 10);
                let key = this.$functions.utcDate(a[i].timestamp,1000).toISOString().slice(0, 10);
                if(aObj[key]==null) {
                  aObj[key] = [];
                }
                aObj[key].push(a[i]);
              }
              return aObj;
            } else {
              return null;
            }
          } else {
            return null;
          }
          // return { 
          //   "2022-01-07": [{
          //       "name": "T3ProbeFail",
          //       "timestamp": 1640886731000,
          //       "active": true
          //     },{
          //       "name": "T3ProbeFail",
          //       "timestamp": 1640886731000,
          //       "active": false
          //     }],
          //   "2022-01-05": ["a","s"],
          //   "2022-01-04": ["z","x"],
          //   "2022-01-03": ["z","x"],
          //   "2022-01-02": ["z","x"],
          //   "2022-01-01": ["z","x"],
          //   }
        }
    },
    methods: {
      formatDate(name) {
        try {
          return this.$d(new Date(name), "medium");
        } catch(err) {
          console.error(err);
          return "Invalid date";
        }
      },
      formatTime(timestamp) {
        try {
          if(this.is24hour) {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time");
          } else {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time12");
          }
        } catch(err) {
          console.error(err);
          return "N/A";
        }
      }
    }
}
</script>

<style >



</style>